<template>
<div id="app" class="home site container hfeed content-page-wrap">
  <HeadNav selectedLanguage="en" page="gb" />

  <div class="site-content">
    <article class="content-page home-page">

      <!-- Hero Banner（竞品双栏风格） -->
      <header id="download" class="hero-banner">
        <div class="hero-text">
          <h1>GB WhatsApp Download Latest Version</h1>
          <p class="hero-desc">
            Get the latest GB WhatsApp APK for Android — free to download, updated regularly, and packed with privacy tools, custom themes, and dual account support that the official app does not offer.
          </p>
          <button class="hero-download-btn" @click="goToDownloadPage">
            <img src="@/assets/android.svg" alt="Android" />
            Download GB WhatsApp APK
          </button>
          <div class="trust-badges">
            <div class="badge-item" v-for="badge in trustBadges" :key="badge">
              <span class="badge-icon">✓</span>
              {{ badge }}
            </div>
          </div>
        </div>
        <div class="hero-visual">
          <img src="@/assets/gb-logo.png" alt="GB WhatsApp" class="hero-logo" width="220" height="220" />
        </div>
      </header>

      <!-- 快速信息条 -->
      <div class="quick-stats">
        <div class="stat-item" v-for="stat in quickStats" :key="stat.label">
          <span class="stat-value">{{ stat.value }}</span>
          <span class="stat-label">{{ stat.label }}</span>
        </div>
      </div>

      <nav class="toc-nav">
        <a v-for="item in tocItems" :key="item.id" href="javascript:void(0)" @click="scrollToSection(item.id)">{{ item.label }}</a>
      </nav>

      <!-- Section 1: Intro -->
      <section id="intro" class="content-section">
        <h2>What Is GB WhatsApp?</h2>
        <div class="intro-split">
          <div>
            <p><a href="/"><strong>GB WhatsApp</strong></a> is a modified version of WhatsApp that adds features the official app simply does not offer — from hiding your online status to running two accounts on a single phone. It is a WhatsApp mod built by third-party developers, not by Meta, which means you get extra privacy tools, thousands of themes, and larger file sharing limits without paying a subscription fee.</p>
            <p>If you want more control over how your chats look and who can see your activity, <a href="/"><strong>GB WhatsApp APK</strong></a> is worth a closer look. It suits privacy-conscious users, people who manage two phone numbers, and anyone tired of the limited customization in the standard WhatsApp client.</p>
          </div>
          <div class="intro-highlights">
            <div class="intro-stat" v-for="item in introStats" :key="item.label">
              <span class="intro-stat-icon">{{ item.icon }}</span>
              <div>
                <strong>{{ item.value }}</strong>
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Section 2: Key App Information -->
      <section id="app-info" class="content-section">
        <h2>Key App Information</h2>
        <div class="info-with-cta">
          <table class="info-table">
            <tbody>
              <tr><th>Latest Version</th><td>{{ appInfo.version }}</td></tr>
              <tr><th>APK Size</th><td>{{ appInfo.apkSize }}</td></tr>
              <tr><th>Android Requirement</th><td>{{ appInfo.androidReq }}</td></tr>
              <tr><th>Category</th><td>Communication / Messaging</td></tr>
              <tr><th>Last Updated</th><td>{{ appInfo.updateMonth }}</td></tr>
            </tbody>
          </table>
          <div class="side-cta">
            <button class="side-cta-btn" @click="goToDownloadPage">Get APK Now</button>
            <p class="side-cta-note">Free download · No signup</p>
          </div>
        </div>
      </section>

      <!-- Section 3: Why Choose -->
      <section class="content-section">
        <h2>Why Choose GB WhatsApp</h2>
        <p>Official WhatsApp works well for everyday messaging, but it keeps customization and privacy controls fairly basic. You cannot hide your online status, freeze your last seen time, or recover messages someone deleted after you already read them — and running two numbers on one phone requires a separate clone app.</p>
        <p>GB WhatsApp fills those gaps with real privacy tools, built-in dual account support, and the ability to send larger files without heavy compression. Everything is free with no ads in your chats, though you should understand that as a third-party mod, it comes with trade-offs around official support and account safety that we cover later on this page.</p>
      </section>

      <!-- New Features 图标网格（竞品风格） -->
      <section id="new-features" class="content-section">
        <h2>New Features</h2>
        <div class="new-features-grid">
          <div class="new-feat-item" v-for="feat in newFeatures" :key="feat.title">
            <span class="feat-emoji" aria-hidden="true">{{ feat.icon }}</span>
            <span>{{ feat.title }}</span>
          </div>
        </div>
      </section>

      <!-- Section 4: Top Features -->
      <section id="features" class="content-section">
        <h2>Top Features of GB WhatsApp</h2>
        <div class="feature-grid">
          <div class="feature-card" v-for="feat in topFeatures" :key="feat.title">
            <h3>{{ feat.title }}</h3>
            <p>{{ feat.text }}</p>
          </div>
        </div>
      </section>

      <!-- 功能详解区块（竞品 highlight 风格） -->
      <section id="highlights" class="content-section">
        <h2>Feature Highlights</h2>

        <div class="highlight-block">
          <div class="highlight-icon-panel" aria-hidden="true">🛡️</div>
          <div class="highlight-content">
            <h3>Anti-Delete Messages and Status Recovery</h3>
            <p>GB WhatsApp can keep a copy of messages and statuses even after the sender deletes them for everyone — and it does this without notifying the other person. This is especially useful when someone sends something important and quickly removes it, or when you need to reference a status update that has already disappeared from the official app.</p>
            <div class="mini-steps">
              <strong>How to enable:</strong>
              <ol>
                <li>Open GB WhatsApp → Settings → Privacy</li>
                <li>Tap Anti-Delete</li>
                <li>Turn on for Chats and Statuses</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="highlight-block reverse">
          <div class="highlight-icon-panel" aria-hidden="true">🔕</div>
          <div class="highlight-content">
            <h3>DND Mode for Distraction-Free Use</h3>
            <p>DND Mode lets you pause all incoming calls and notifications while keeping GB WhatsApp open — ideal for focused work, study sessions, or uninterrupted sleep. Unlike turning on airplane mode, you can still read and compose messages inside the app, so you stay in control of when you actually go online.</p>
            <div class="mini-steps">
              <strong>How to enable:</strong>
              <ol>
                <li>Go to Settings → Tools</li>
                <li>Tap DND Mode</li>
                <li>Select silent duration or focus mode</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="highlight-block">
          <div class="highlight-icon-panel" aria-hidden="true">👁️</div>
          <div class="highlight-content">
            <h3>Advanced Privacy Controls</h3>
            <p>GB WhatsApp gives you granular control over your visibility — hide your online status, freeze your last seen timestamp, and decide exactly when blue ticks and typing indicators appear. You can also lock the app with your fingerprint and set different privacy rules for individual chats, which is something the official client does not support at this level.</p>
            <div class="mini-steps">
              <strong>How to manage visibility:</strong>
              <ol>
                <li>Settings → Privacy</li>
                <li>Enable Hide Online or Freeze Last Seen</li>
                <li>Use quick toggles for blue ticks and typing indicator</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="highlight-block reverse">
          <div class="highlight-icon-panel" aria-hidden="true">📁</div>
          <div class="highlight-content">
            <h3>Large File and Media Sharing</h3>
            <p>Sharing large videos, photos, and documents is much easier with GB WhatsApp, which supports bigger file sizes and applies less compression to HD media than the official app. You can also save other people's status updates directly to your phone gallery — a small but genuinely useful feature if you frequently receive media you want to keep.</p>
            <div class="mini-steps">
              <strong>How to share large files:</strong>
              <ol>
                <li>Open a chat → tap Attachment</li>
                <li>Select Files or Gallery</li>
                <li>Pick your file and tap Send</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <!-- 性能简述（竞品 What Makes 风格，保持中立） -->
      <section class="content-section">
        <h2>What Makes GB WhatsApp App Worth Trying</h2>
        <p>Version {{ appInfo.versionNum }} brings noticeable performance improvements over older builds — chats load faster, memory usage is lower, and mid-range Android phones handle daily use without lag. Bug fixes from recent releases also mean fewer crashes during heavy media sharing and smoother video playback in group chats.</p>
        <p>The interface has been refined as well, with cleaner transitions between chats, settings, and media sections. If you tried an older GB WhatsApp build and found it sluggish, the current version is a meaningful step up in both speed and stability.</p>
      </section>

      <!-- Section 5: Who Should Use（文档顺序：对比表之前） -->
      <section id="who-should-use" class="content-section">
        <h2>Who Should Use GB WhatsApp</h2>
        <ul>
          <li><strong>Users who want more privacy controls</strong> — hide online status, freeze last seen, read deleted messages</li>
          <li><strong>Users who need dual accounts</strong> — run two WhatsApp numbers on one phone without a clone app</li>
          <li><strong>Users who like custom themes</strong> — change chat colors, fonts, and bubble styles freely</li>
          <li><strong>Users who share large files frequently</strong> — send bigger videos and documents than the official limit</li>
        </ul>
      </section>

      <!-- Section 6: Comparison -->
      <section id="comparison" class="content-section">
        <h2>GB WhatsApp vs Official WhatsApp</h2>
        <table class="compare-table">
          <thead>
            <tr>
              <th>Feature</th>
              <th>GB WhatsApp</th>
              <th>Official WhatsApp</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in compareRows" :key="row[0]">
              <td v-for="(cell, i) in row" :key="i">{{ cell }}</td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- Section 7: Safety -->
      <section id="safety" class="content-section">
        <h2>Is GB WhatsApp Safe</h2>
        <p>GB WhatsApp is <strong>not an official app</strong>, and Meta does not support, verify, or endorse it in any way. That does not automatically make it dangerous, but it does mean you are using modified code outside WhatsApp's normal security and update pipeline — which carries real risks around account bans and unverified APK sources.</p>
        <p>We strongly recommend downloading only from trusted websites and backing up your chats before installing, so your messages are protected if anything goes wrong. Every user should weigh the extra features against these risks for themselves. Our <a href="/is-gb-whatsapp-safe/"><strong>full safety guide</strong></a> walks through the trade-offs in detail so you can make an informed decision.</p>
      </section>

      <!-- Section 8: Install -->
      <section id="install" class="content-section">
        <h2>How to Download and Install GB WhatsApp</h2>
        <StepByStep :steps="installSteps" />
        <p>Need more help? See our <a href="/gb-whatsapp-install/"><strong>detailed install guide</strong></a>.</p>
      </section>

      <!-- Section 9: Pros and Cons -->
      <section class="content-section">
        <h2>Pros and Cons</h2>
        <div class="pros-cons">
          <div class="pros-box">
            <h3>Pros</h3>
            <ul>
              <li>Free with no ads in chats</li>
              <li>Strong privacy and anti-delete features</li>
              <li>Thousands of custom themes</li>
              <li>Dual account on one phone</li>
              <li>Larger file sharing limits</li>
              <li>Auto reply and DND mode</li>
            </ul>
          </div>
          <div class="cons-box">
            <h3>Cons</h3>
            <ul>
              <li>Not on Google Play Store</li>
              <li>Possible account ban from WhatsApp</li>
              <li>No official customer support</li>
              <li>Must manually update the APK</li>
              <li>Security depends on download source</li>
            </ul>
          </div>
        </div>
      </section>

      <!-- FAQ（扩展至 6 条，竞品风格） -->
      <section id="faq" class="content-section">
        <h2>Frequently Asked Questions</h2>
        <FAQ :faqs="homeFaqs" />
      </section>

      <!-- Conclusion -->
      <section class="content-section conclusion">
        <h2>Bottom Line</h2>
        <p>GB WhatsApp is a strong fit for Android users who want deeper privacy controls, full theme customization, and dual account support without juggling multiple apps. It is not the right choice for everyone — if keeping your main number safe on an officially supported client is your top priority, the standard WhatsApp app remains the more secure option.</p>
        <p>If the extra features genuinely matter to you, download the latest version above, follow the install steps, and back up your chats before you switch. You can also visit <a href="https://gb-wave.com/">GB Wave</a> for another related resource. Use the app responsibly, keep it updated, and you will get the most out of what GB WhatsApp has to offer.</p>
      </section>

      <div class="download-cta">
        <button class="download-btn" @click="goToDownloadPage">
          <img src="@/assets/android.svg" alt="Android" />
          Download GB WhatsApp Latest Version
        </button>
      </div>
    </article>
  </div>

  <div v-if="showFixedBar" class="fixed-download-bar" @click="goToDownloadPage">
    <img src="@/assets/android.svg" alt="Android" />
    Download GB WhatsApp ({{ appInfo.version }})
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/content-page.scss';
import '@/css/home.scss';
import HeadNav from '@/components/HeadNav.vue';
import FAQ from '@/components/FAQ.vue';
import StepByStep from '@/components/StepByStep.vue';
import { APP_INFO } from '@/data/app-info';

const DOWNLOAD_PAGE = '/gb-whatsapp-latest-version/';

export default {
  name: 'Home',
  components: { HeadNav, FAQ, StepByStep },
  data() {
    return {
      appInfo: APP_INFO,
      showFixedBar: false,
      trustBadges: ['Anti-Ban Build', 'Regular Updates'],
      quickStats: [
        { value: APP_INFO.version, label: 'Version' },
        { value: APP_INFO.apkSize, label: 'APK Size' },
        { value: 'Android 5+', label: 'Requirement' },
        { value: APP_INFO.updateLabel, label: 'Updated' },
      ],
      introStats: [
        { icon: '👥', value: '2 Accounts', label: 'On one phone' },
        { icon: '🎨', value: '1000+', label: 'Custom themes' },
        { icon: '📎', value: '1 GB', label: 'File sharing' },
        { icon: '🔒', value: 'Privacy', label: 'Full control' },
      ],
      newFeatures: [
        { title: 'Dual Accounts', icon: '👥' },
        { title: 'Status Saver', icon: '💾' },
        { title: 'Advanced Privacy', icon: '🔒' },
        { title: 'Media Sharing', icon: '📎' },
        { title: 'Auto Reply', icon: '💬' },
      ],
      topFeatures: [
        { title: 'Hide Online Status', text: 'Browse and reply to messages without showing the green online dot — useful when you want to read chats privately without others knowing you are active.' },
        { title: 'Freeze Last Seen', text: 'Display a fixed "last seen" timestamp even while you are using the app, so your contacts cannot track your real activity patterns.' },
        { title: 'Custom Themes', text: 'Personalize chat colors, fonts, wallpapers, and bubble styles with thousands of built-in themes — far beyond the light and dark modes in official WhatsApp.' },
        { title: 'Anti Delete Messages', text: 'Keep a copy of messages that others delete for everyone, so important information is not lost when someone changes their mind.' },
        { title: 'Anti Delete Status', text: 'View status updates that have already been removed, which is handy when someone shares something briefly and then takes it down.' },
        { title: 'Dual Accounts', text: 'Run two WhatsApp numbers on one phone without installing a separate clone app — ideal for separating work and personal messaging.' },
        { title: 'Large File Sharing', text: 'Send videos and documents larger than the official app allows, with less compression applied to HD media files.' },
        { title: 'Auto Reply', text: 'Set automatic responses for when you are busy or away, so contacts know you will get back to them without you having to type each time.' },
        { title: 'DND Mode', text: 'Pause all notifications and calls while still being able to read and write messages inside the app — a smarter alternative to airplane mode.' },
      ],
      installSteps: [
        'Tap the download button at the top of this page.',
        'Go to Settings → Security → allow installs from your browser.',
        'Open the downloaded APK file and tap Install.',
        'Enter your phone number and verify with the OTP code.',
        'Restore your chat backup if you are switching from official WhatsApp.',
      ],
      compareRows: [
        ['Customization', 'High', 'Limited'],
        ['Privacy', 'Advanced controls', 'Basic settings'],
        ['Themes', 'Thousands available', 'Light / dark only'],
        ['File Sharing', 'Up to 1 GB', 'Up to 2 GB'],
        ['Dual Accounts', 'Yes', 'No'],
        ['Official Support', 'No', 'Yes'],
      ],
      tocItems: [
        { id: 'intro', label: 'About' },
        { id: 'app-info', label: 'App Info' },
        { id: 'new-features', label: 'Features' },
        { id: 'highlights', label: 'Highlights' },
        { id: 'comparison', label: 'vs Official' },
        { id: 'safety', label: 'Safety' },
        { id: 'install', label: 'Install' },
        { id: 'faq', label: 'FAQ' },
      ],
      homeFaqs: [
        {
          question: 'Is GB WhatsApp free?',
          answer: 'Yes — GB WhatsApp is completely free to download and use. There is no subscription, no in-app purchase, and no hidden fee. The APK on this site is provided at no cost, though you should always download from a trusted source to avoid tampered files.',
        },
        {
          question: 'Is GB WhatsApp safe?',
          answer: 'GB WhatsApp is not an official app, so it carries risks that the standard WhatsApp client does not — including possible account bans and security concerns around unverified APK sources. Downloading from trusted sites and backing up your chats before installing significantly reduces avoidable problems. Read our <a href="/is-gb-whatsapp-safe/"><strong>is GB WhatsApp safe</strong></a> page for a balanced, detailed assessment.',
        },
        {
          question: 'Can I use it with official WhatsApp?',
          answer: 'You cannot run both apps with the same phone number on a single device, because they share the same package slot. However, you can use GB WhatsApp for one number and official WhatsApp for a different number on the same phone via dual account support, or run each app on separate devices.',
        },
        {
          question: 'Will I lose my chats?',
          answer: 'Your chats are safe as long as you back up before switching and install the new APK over your existing version without uninstalling first. Go to Settings → Chats → Back up chats to save everything to Google Drive. If you uninstall without a backup, locally stored messages will be permanently removed.',
        },
        {
          question: 'How do I update GB WhatsApp?',
          answer: 'Download the newest APK from our site and install it directly over your current version — do not uninstall first, or you risk losing unsaved chats. The process takes a few minutes and keeps your settings intact. See our <a href="/gb-whatsapp-update/"><strong>GB WhatsApp update guide</strong></a> for step-by-step instructions.',
        },
      ],
    };
  },
  watch: {
    '$route.hash'(hash) {
      if (hash) {
        this.$nextTick(() => {
          this.scrollToSection(hash.replace('#', ''));
        });
      }
    },
  },
  mounted() {
    if (typeof window !== 'undefined' && this.$global.isMobileDevice()) {
      this.showFixedBar = true;
    }
    if (this.$route.hash) {
      this.$nextTick(() => {
        this.scrollToSection(this.$route.hash.replace('#', ''));
      });
    }
  },
  methods: {
    goToDownloadPage() {
      this.$router.push(DOWNLOAD_PAGE);
    },
    scrollToSection(id) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.conclusion {
  background: #f8fdf9;
  border-color: #c8e6d5;
}

.fixed-download-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #25D366, #128C7E);
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);

  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
}

.home-page {
  padding-bottom: 80px;
}
</style>
